<div class="order-common-row-view py-2 py-md-0">
  <div class="row g-0 align-items-center justify-content-between bar">
    <div *ngIf="identificatorConfig.actualData" class="col-12 col-md-auto text-center text-md-start my-2 my-md-0">
      <app-component-resolver [data]="identificatorConfig.actualData" [config]="identificatorConfig">
      </app-component-resolver>
    </div>
    <div *ngIf="markersConfig.actualData" class="col-12 col-md-auto my-2 my-md-0"
      [ngClass]="{'col-md-6': !executersConfig.actualData}">
      <app-component-resolver [data]="markersConfig.actualData" [config]="markersConfig">
      </app-component-resolver>
    </div>
    <div *ngIf="executersConfig.actualData" class="col-12 col-md-auto">
      <app-component-resolver [data]="executersConfig.actualData" [config]="executersConfig">
      </app-component-resolver>
    </div>
    <div *ngIf="actionsConfig.actualData" class="col-12 col-md-auto text-center text-md-end">
      <app-component-resolver [data]="actionsConfig.actualData" [config]="actionsConfig">
      </app-component-resolver>
    </div>
    <div *ngIf="actionMenuConfig.actualData" class="col-12 col-md-auto text-center text-md-end">
      <app-component-resolver [data]="actionMenuConfig.actualData" [config]="actionMenuConfig">
      </app-component-resolver>
    </div>
  </div>
</div>